import { makeStyles } from '@material-ui/core';

import {
  blue,
  green,
  neutral,
  orange,
  red,
  yellow,
} from 'shared/styles/colors';

import type { SubstitutionFlowStatus } from 'shared/domain';
import type { Props } from './substitutionFlowStatusChip.model';

export default makeStyles({
  root: ({ status, size, variant }: Props) => ({
    height: 'fit-content',
    width: 'fit-content',
    padding: size === 'regular' ? '0.125rem 0.5rem' : '0 0.5rem',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    borderRadius: '1.25rem',
    '& [aria-label="countdown"]': {
      fontFamily: 'Inconsolata, monospace, PP Object Sans, sans-serif',
      fontSize: '0.875rem',
      fontWeight: 'bolder',
    },
    ...resolveColor({ status, variant }),
  }),
});

interface ColorConfig {
  first: string;
  second: string;
  third: string;
}
const _COLOR_MAP: Record<SubstitutionFlowStatus, ColorConfig> = {
  awaiting: { first: orange[70], second: yellow[20], third: yellow[50] },
  timeout: { first: red[70], second: red[10], third: red[50] },
  another: { first: blue[60], second: blue[20], third: blue[50] },
  accepted: { first: green[70], second: green[20], third: green[50] },
  chat: { first: blue[60], second: blue[20], third: blue[50] },
  refused: { first: red[70], second: red[10], third: red[50] },
} as const;

function resolveColor(params: Pick<Props, 'status' | 'variant'>) {
  const { status = 'awaiting', variant } = params;
  const isVariantPrimary = variant === 'primary';
  const baseColor = _COLOR_MAP[status].first;
  return {
    color: isVariantPrimary ? baseColor : neutral[70],
    backgroundColor: isVariantPrimary
      ? _COLOR_MAP[status].second
      : neutral.white,
    border: `1px solid ${
      isVariantPrimary ? _COLOR_MAP[status].second : neutral[20]
    }`,
    '& > [aria-label="icon"]': {
      width: '1rem',
      height: '1rem',
      fontSize: '1rem',
      fill: isVariantPrimary ? baseColor : _COLOR_MAP[status].third,
    },
    ...(!isVariantPrimary && {
      '& > [aria-label="label"]': {
        fill: neutral[70],
      },
    }),
  };
}
